<template>
  <div
    role="tablist"
    class="relative h-16 w-[243px] rounded-full border border-white/60 bg-white/70 shadow-[0_8px_40px_0_rgba(0,0,0,0.12)] backdrop-blur-xl"
    :class="disabled && 'pointer-events-none opacity-50'"
  >
    <span
      class="absolute top-[5px] left-[3px] h-[54px] w-[86px] rounded-full bg-[#787880]/16 transition-transform duration-300 ease-out"
      :style="{ transform: `translateX(${index * 75}px)` }"
      aria-hidden="true"
    />
    <div class="absolute top-[5px] left-[3px] flex">
      <button
        v-for="(item, position) in MODES"
        :key="item.value"
        type="button"
        role="tab"
        :aria-selected="item.value === mode"
        class="flex h-[54px] w-[86px] cursor-pointer flex-col items-center justify-center"
        :class="[
          position && '-ml-[11px]',
          item.value === mode ? 'text-green-900' : 'text-[#404040]',
        ]"
        @click="emit('change', item.value)"
      >
        <component :is="item.icon" class="size-[22px]" aria-hidden="true" />
        <span class="mt-1 text-[10px] leading-[13px] font-medium">
          {{ item.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CameraIcon, UploadIcon, VocalAndInstrumentalIcon } from '@dacr/icons'

import type { CheckerMode } from './useChecker'

const props = defineProps<{ mode: CheckerMode; disabled?: boolean }>()

const emit = defineEmits<{ change: [mode: CheckerMode] }>()

const MODES = [
  { value: 'audio', label: 'Audio', icon: VocalAndInstrumentalIcon },
  { value: 'visual', label: 'Visual', icon: CameraIcon },
  { value: 'upload', label: 'Upload', icon: UploadIcon },
] as const

const index = computed(() =>
  MODES.findIndex((item) => item.value === props.mode)
)
</script>
